module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/030-north-korea-5cb7fbd7be7b04ee9563f2e383b4dcef.svg";